const RolesMapping = [
    {
        _id: "forms-completer",
        name: "Forms Completer",
        uiPermissionsList: [
            "View Domain Settings",
            "View Deployment",
            "Fill In Forms"
        ]
    },
    {
        _id: "forms-admin",
        name: "Forms Admin",
        uiPermissionsList: [
            "View Domain Settings",
            "View Deployment",
            "Edit Deployment",
            "View Users",
            "Edit Users",
            "View Forms",
            "Edit Forms",
            "View Form Instances",
            "Manage Form Instances",
            "Fill In Forms"
        ]
    }
];

export const getRoleAssignedToUser = ({
    userPermissions,
    allPermissions,
    selectedDomain,
    deploymentId
}) => {
    const userPermissionsForDeployment = (userPermissions || []).filter(
        (uiPermission) => {
            const permission = allPermissions.find(
                ({ _id }) => _id === uiPermission._id
            );

            return (
                permission?.deployment === null ||
                permission?.deployment._id === deploymentId
            );
        }
    );
    const sortedUserPermissions = userPermissionsForDeployment
        .map(({ _id }) => _id)
        .sort();

    return RolesMapping.find(({ uiPermissionsList }) => {
        const deploymentPermissionsForRole = [];
        uiPermissionsList.forEach((permissionName) => {
            deploymentPermissionsForRole.push(
                ...allPermissions.filter(({ name, domain, deployment }) => {
                    const deploymentMatches =
                        deployment === null || deployment._id === deploymentId;

                    return (
                        name === permissionName &&
                        domain._id === selectedDomain &&
                        deploymentMatches
                    );
                })
            );
        });

        if (
            deploymentPermissionsForRole.length !== sortedUserPermissions.length
        ) {
            return false;
        }

        const sortedRolePermissions = deploymentPermissionsForRole
            .map(({ _id }) => _id)
            .sort();

        for (let i = 0; i < sortedRolePermissions.length; i += 1) {
            if (sortedRolePermissions[i] !== sortedUserPermissions[i]) {
                return false;
            }
        }

        return true;
    });
};

export default RolesMapping;
